var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ms-logo",style:({ fontSize: _vm.size + 'px' })},[_vm._m(0),(_vm.byline)?_c('span',{staticClass:"ms-logo__byline"},[_vm._v(_vm._s(_vm.copy[_vm.$lang].brand.byline))]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ms-logo__word"},[_vm._v("Mira "),_c('span',{staticClass:"ms-logo__accent"},[_vm._v("Solutions")])])
}]

export { render, staticRenderFns }